/**
 * Shared report shell — filter controls at top, export buttons, content area.
 */

import { Button } from '../common';

export default function ReportShell({
  title,
  children,
  filters,
  onExportCSV,
  onExportPDF,
  exporting,
}) {
  return (
    <div className="space-y-4">
      {/* Filters + export */}
      <div className="bg-white rounded-lg border border-gray-200 px-4 py-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3 flex-wrap">
            {filters}
          </div>
          <div className="flex items-center gap-2">
            {onExportCSV && (
              <Button size="sm" variant="ghost" loading={exporting === 'csv'} onClick={onExportCSV}>
                CSV
              </Button>
            )}
            {onExportPDF && (
              <Button size="sm" variant="ghost" loading={exporting === 'pdf'} onClick={onExportPDF}>
                PDF
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      {children}
    </div>
  );
}

export function DateRangeFilter({ dateFrom, dateTo, onChangeFrom, onChangeTo }) {
  return (
    <>
      <div>
        <label className="block text-xs text-gray-500 mb-0.5">From</label>
        <input
          type="date"
          className="border border-gray-300 rounded-md px-2 py-1 text-sm"
          value={dateFrom}
          onChange={(e) => onChangeFrom(e.target.value)}
        />
      </div>
      <div>
        <label className="block text-xs text-gray-500 mb-0.5">To</label>
        <input
          type="date"
          className="border border-gray-300 rounded-md px-2 py-1 text-sm"
          value={dateTo}
          onChange={(e) => onChangeTo(e.target.value)}
        />
      </div>
    </>
  );
}
